<template>
  <div>
    <div>
      <div class="panel-item">
        <el-form :model="currentDiscountForm" ref="discountForm">
          <el-form-item>
            <el-radio-group
              v-model="discountForm.discount_item_type"
              class="block mt10"
              @change="radioState(discountForm.discount_item_type)"
            >
              <el-radio
                class="block mb20"
                v-for="type in discountItemTypesMall"
                :key="type.value"
                :label="type.value"
                >{{ type.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <div
            v-if="
              discountForm.discount_item_type === 'specific_product'
            "
          >
            <div>
              <el-button
                icon="el-icon-search"
                @click="visibleProductDialog = true"
                >Бүтээгдэхүүн сонгох</el-button
              >
            </div>
            <div
              v-if="
                discountForm.discount_item_type === 'specific_product'
              "
            >
              <div
                v-for="(product, index) in discountForm.products"
                :key="index"
              >
                <div
                  v-for="(variant, index1) in product.variants"
                  :key="index1"
                >
                  <el-row
                    :gutter="5"
                    type="flex"
                    align="middle"
                    class="mt10 pt10 border-top"
                  >
                    <el-col :xl="4" :lg="4" :md="6" :sm="6" :xs="6">
                      <el-carousel :interval="4000" indicator-position="outside" height="80px">
                        <el-carousel-item v-for="item in variant.variant_image" :key="item">
                          <img :src="item" alt="" class="item__image">
                        </el-carousel-item>
                      </el-carousel>
                    </el-col>
                    <el-col
                      :xl="16"
                      :lg="16"
                      :md="14"
                      :sm="14"
                      :xs="14"
                    >
                      <el-row class="text-color-secondary" style="font-size: 0.8vw;">
                        {{ product.name_mon }}
                      </el-row>
                      <el-row style="font-size: 0.8vw;">{{ variant.variant_name }}</el-row>
                      <el-row style="color: grey; font-size: 0.8vw;">
                        {{ variant.variant_sku }}
                      </el-row>
                    </el-col>
                    <el-col :xl="6" :lg="6" :md="4" :sm="4" :xs="4">
                      <el-input
                        v-model="
                          discountForm.products[index].variants[
                            index1
                          ].min_count
                        "
                        placeholder="Доод хязгаар"
                        type="number"
                      ></el-input>
                    </el-col>
                    <el-col :xl="6" :lg="6" :md="4" :sm="4" :xs="4">
                      <el-input
                        v-model="
                          discountForm.products[index].variants[
                            index1
                          ].max_count
                        "
                        placeholder="Дээд хязгаар"
                        type="number"
                      ></el-input>
                    </el-col>
                    <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="4">
                      <div class="text-right">
                        <i
                          class="el-icon-close cursor-pointer"
                          @click="
                            deleteVariantFromDiscount(
                              product,
                              variant
                            )
                          "
                        ></i>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="discountForm.discount_item_type === 'category'"
          >
            <el-input
              placeholder="Эрэгтэй, эмэгтэй, гутал ..."
              v-model="treeFilterText"
            >
              <el-button
                slot="prepend"
                icon="el-icon-search"
              ></el-button>
            </el-input>
            <el-tree
              :data="categories"
              :props="treeDefaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
              ref="tree"
              class="mt20"
            >
            </el-tree>
            <div v-if="checkedNodes !== null">
              <el-row :gutter="20" class="border-top pt20 mt20">
                <el-col :span="10" class="pt10">
                  <strong>{{ checkedNodes.name_mon }}</strong>
                </el-col>
                <el-col :span="5">
                  <el-form-item prop="category_min_count">
                    <el-input
                      placeholder="Доод хязгаар"
                      v-model="discountForm.category_min_count"
                      @input="onChangeDiscountForm()"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item prop="category_max_count">
                    <el-input
                      placeholder="Дээд хязгаар"
                      v-model="discountForm.category_max_count"
                      @input="onChangeDiscountForm()"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-else-if="discountForm.discount_item_type === 'supplier'"
          >
            <div>
              <el-button
                icon="el-icon-search"
                @click="visibleSupplierDialog = true"
                >Нийлүүлэгч сонгох</el-button
              >
            </div>
            <div v-if="discountForm.suppliers !== null">
              <el-row :gutter="20" class="border-top pt20 mt20">
                <el-col :span="10" class="pt10">
                  <strong>{{ discountForm.suppliers.supplier_monName }}</strong>
                </el-col>
                  <el-col :span="5">
                    <el-form-item >
                      <el-input
                        placeholder="Доод хязгаар"
                        v-model="discountForm.supplier_min_count"
                        @input="onChangeDiscountForm()"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item >
                      <el-input
                        placeholder="Дээд хязгаар"
                        v-model="discountForm.supplier_max_count"
                        @input="onChangeDiscountForm()"
                      ></el-input>
                    </el-form-item>
                  </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-else-if="discountForm.discount_item_type === 'brand'"
          >
            <div>
              <el-button
                icon="el-icon-search"
                @click="visibleBrandDialog = true"
                >Брэнд сонгох</el-button
              >
            </div>
            <div v-if="currentDiscountForm && currentDiscountForm.brands !== null && currentDiscountForm.brands.brand_monName">
              <el-row :gutter="20" class="border-top pt20 mt20">
                <el-col :span="10" class="pt10">
                  {{ currentDiscountForm.brands.brand_monName }}
                </el-col>
                <el-col :span="5">
                  <el-form-item prop="brand_min_count">
                    <el-input
                      @input="onChangeDiscountForm()"
                      placeholder="Доод хязгаар"
                      v-model.number="currentDiscountForm.brand_min_count"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item prop="brand_max_count">
                    <el-input
                      type="number"
                      @input="onChangeDiscountForm()"
                      placeholder="Дээд хязгаар"
                      v-model.number="currentDiscountForm.brand_max_count"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <product-search-dialog
      v-if="visibleProductDialog"
      :visibleProductDialog.sync="visibleProductDialog"
      :products.sync="returnTempProducts"
      :discountForm="currentDiscountForm"
      :mergeProduct="mergeProduct"
    ></product-search-dialog>
    <supplier-search-dialog
      v-if="visibleSupplierDialog"
      :visible-supplier-dialog.sync="visibleSupplierDialog"
      :suppliers.sync="currentDiscountForm.suppliers"
    ></supplier-search-dialog>
    <brand-search-dialog
      v-if="visibleBrandDialog"
      :visible-brand-dialog.sync="visibleBrandDialog"
      :brands.sync="currentDiscountForm.brands"
    ></brand-search-dialog>
  </div>
</template>
<script>
import services from '../../../helpers/services'
import ProductSearchDialog from './productSearchDialog'
import SupplierSearchDialog from './supplierSearchDialog'
import BrandSearchDialog from './brandSearchDialog'
export default {
  name: 'addDiscountMall',
  components: {
    ProductSearchDialog,
    SupplierSearchDialog,
    BrandSearchDialog
  },
  props: {
    discountForm: {
      type: Object, default: () => () => {}
    },
    discountItemTypesMall: {
      type: Array, default: () => () => []
    },
    forceUpdateFunction: {
      type: Function, default: () => () => null
    },
    handleNodeClick: {
      type: Function, default: () => () => null
    },
    checkedNodes: {
      type: Object, default: () => () => {}
    }
  },
  data () {
    return {
      currentDiscountForm: this.discountForm,
      returnTempProducts: [],
      isDisabled: false,
      activeStep: 1,
      min_count: '',
      max_count: '',
      visibleProductDialog: false,
      visibleSupplierDialog: false,
      visibleBrandDialog: false,
      categories: [],
      treeFilterText: '',
      treeDefaultProps: {
        children: 'childrens',
        label: 'name_mon'
      },
      discountFormRules: {
        type: [
          {
            required: true,
            message: 'Хямдралийн төрөл сонгоно уу',
            trigger: 'blur'
          }
        ],
        discount_code: [
          {
            required: true,
            message: 'Хямдралийн код оруулна уу',
            trigger: ['blur', 'change']
          }
        ],
        title_mon: [
          { required: true, message: 'Монгол нэр оруулна уу', trigger: 'blur' }
        ],
        title_eng: [
          { required: true, message: 'Англи нэр оруулна уу?', trigger: 'blur' }
        ],
        desc_mon: [
          {
            required: true,
            message: 'Монгол тайлбар оруулна уу',
            trigger: 'blur'
          }
        ],
        desc_eng: [
          {
            required: true,
            message: 'Англи тайлбар оруулна уу',
            trigger: 'blur'
          }
        ],
        max_item_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ],
        min_item_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ],
        users: [
          {
            required: true,
            message: 'Утасны дугаар бичээгүй байна!!!',
            trigger: 'blur'
          }
        ],
        end_date: [
          {
            required: true,
            message: 'Дуусах хугацааг оруулна уу !!!',
            trigger: 'blur'
          }
        ],
        category_max_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ],
        category_min_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ],
        supplier_max_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ],
        supplier_min_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: ['blur', 'change']
          }
        ],
        brand_max_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ],
        brand_min_count: [
          {
            required: true,
            message: 'Энэ талбарыг бөглөнө үү!!!',
            trigger: 'blur'
          }
        ]
      },
      suggestedAddresses: [],
      suppliers: []
    }
  },

  created () {
    // if (this.$route.query.type === 'DISCOUNT_CODE') {
    //   this.currentDiscountForm.type = 'DISCOUNT_CODE'
    // } else {
    //   this.currentDiscountForm.type = 'AUTO'
    // }
    this.getCategories()
    this.getSuppliers()
  },

  watch: {
    treeFilterText (val) {
      this.$refs.tree.filter(val)
    }
  },

  methods: {
    mergeProduct () {
      if (this.returnTempProducts.length > 0) {
        this.currentDiscountForm.products = this.currentDiscountForm.products.concat(
          this.returnTempProducts
        )
        this.currentDiscountForm.products = [
          ...new Map(
            this.currentDiscountForm.products.map((el) => [el.productId, el])
          ).values()
        ]
      }
    },
    getCategories () {
      this.loading = true
      services.getCategories().then((response) => {
        this.categories = response
        this.loading = false
      })
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name_mon.indexOf(value) !== -1
    },

    deleteVariantFromDiscount (product, delVariant) {
      product.variants = product.variants.filter(
        (variant) => variant !== delVariant
      )
    },
    radioState (data) {
      if (data === 'specific_product') {
        this.currentDiscountForm.categories = null
        this.currentDiscountForm.suppliers = null
        this.currentDiscountForm.brands = null
        this.checkedNodes = null
        this.currentDiscountForm.brand_max_count = null
        this.currentDiscountForm.brand_min_count = null
        this.currentDiscountForm.category_max_count = null
        this.currentDiscountForm.category_min_count = null
        this.currentDiscountForm.supplier_min_count = null
        this.currentDiscountForm.supplier_max_count = null
      } else if (data === 'category') {
        this.currentDiscountForm.products = []
        this.currentDiscountForm.suppliers = null
        this.currentDiscountForm.brands = null
        this.currentDiscountForm.brand_max_count = null
        this.currentDiscountForm.brand_min_count = null
        this.currentDiscountForm.supplier_min_count = null
        this.currentDiscountForm.supplier_max_count = null
      } else if (data === 'supplier') {
        this.currentDiscountForm.products = []
        this.currentDiscountForm.categories = null
        this.checkedNodes = null
        this.currentDiscountForm.brands = null
        this.currentDiscountForm.brand_max_count = null
        this.currentDiscountForm.brand_min_count = null
        this.currentDiscountForm.category_max_count = null
        this.currentDiscountForm.category_min_count = null
      } else if (data === 'brand') {
        this.currentDiscountForm.products = []
        this.currentDiscountForm.categories = null
        this.currentDiscountForm.suppliers = null
        this.checkedNodes = null
        this.currentDiscountForm.category_max_count = null
        this.currentDiscountForm.category_min_count = null
        this.currentDiscountForm.supplier_min_count = null
        this.currentDiscountForm.supplier_max_count = null
      } else if (data === 'all_product') {
        this.currentDiscountForm.products = []
        this.currentDiscountForm.categories = null
        this.currentDiscountForm.suppliers = null
        this.currentDiscountForm.brands = null
        this.checkedNodes = null
        this.currentDiscountForm.brand_max_count = null
        this.currentDiscountForm.brand_min_count = null
        this.currentDiscountForm.category_max_count = null
        this.currentDiscountForm.category_min_count = null
        this.currentDiscountForm.supplier_min_count = null
        this.currentDiscountForm.supplier_max_count = null
      }
    },
    getSuppliers () {
      const query = ''
      services.getSuppliers(query).then((response) => {
        this.suppliers = response.datas
      })
    },
    onChangeDiscountForm () {
      this.$emit('interface', this.currentDiscountForm)
      this.$forceUpdate()
    }
  }
}
</script>
